/**
 * Category Service
 */
import { getApiClient } from '../apiClient';
import { CATEGORY_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
  GetCategoriesResponse,
  GetCategoryResponse,
  CreateCategoryPayload,
  CreateCategoryResponse,
  UpdateCategoryPayload,
  UpdateCategoryResponse,
  DeleteCategoryResponse,
  GetCategoriesParams,
} from '../types/category.types';

export const categoryService = {
  /**
   * Get all categories/subcategories
   * @param params - Optional query params (parentId for filtering subcategories)
   */
  getCategories: (params?: GetCategoriesParams): Promise<GetCategoriesResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.parentId) {
      queryParams.append('parentId', params.parentId);
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.page) {
      queryParams.append('page', String(params.page));
    }
    if (params?.limit) {
      queryParams.append('limit', String(params.limit));
    }
    if (params?.offset) {
      queryParams.append('offset', String(params.offset));
    }
    const url = queryParams.toString() 
      ? `${CATEGORY_ENDPOINTS.getCategories}?${queryParams.toString()}`
      : CATEGORY_ENDPOINTS.getCategories;
    return getApiClient().get(url);
  },

  /**
   * Get single category/subcategory by ID
   */
  getCategory: (id: string): Promise<GetCategoryResponse> => {
    const url = replacePathParams(CATEGORY_ENDPOINTS.getCategory, { id });
    return getApiClient().get(url);
  },

  /**
   * Create category/subcategory
   */
  createCategory: (body: CreateCategoryPayload): Promise<CreateCategoryResponse> => {
    return getApiClient().post(CATEGORY_ENDPOINTS.createCategory, body);
  },

  /**
   * Update category/subcategory
   */
  updateCategory: (id: string, body: UpdateCategoryPayload): Promise<UpdateCategoryResponse> => {
    const url = replacePathParams(CATEGORY_ENDPOINTS.updateCategory, { id });
    return getApiClient().put(url, body);
  },

  /**
   * Delete category/subcategory
   */
  deleteCategory: (id: string): Promise<DeleteCategoryResponse> => {
    const url = replacePathParams(CATEGORY_ENDPOINTS.deleteCategory, { id });
    return getApiClient().delete(url);
  },
};

